// extracted by mini-css-extract-plugin
module.exports = {"container":"OverlapArea_container__OOQs0","overlap":"OverlapArea_overlap__wz9S_","noOverlap":"OverlapArea_noOverlap__jXE2s"};